module.exports = __webpack_public_path__ + "static/media/Horizontal.2d5ab055.png";